import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { sanitizeHTML } from '../../../utils/sanitizeHTML';

export default function CompletedAssessment({ assessment, stepStatus, completeStep }) {
  useEffect(() => {
    if (stepStatus === 'complete') return;
    completeStep();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <p>You have finished the {assessment.name} assessment.</p>
      <p className="text-color-medium">
        {assessment.questions.length} of {assessment.questions.length} questions answered
      </p>
      <div className="text-color-medium" dangerouslySetInnerHTML={{ __html: sanitizeHTML(assessment.overview) }}></div>
    </>
  );
}

CompletedAssessment.propTypes = {
  assessment: PropTypes.object.isRequired,
  stepStatus: PropTypes.string.isRequired,
  completeStep: PropTypes.func.isRequired,
};
